import { styled } from '../../theme';

export const StyledDiv = styled('div')({});
